import BarMenu from "../BarMenu";
import Section from "./Section";

export default function Config(){
    return (
            <div id="Config">
                <BarMenu />
                <section className="profile-config">
                   <Section /> 
                </section>
            </div>
        );
}